<template>
  <div class="orderManager">
    <div class="item">
      <div class="title">控制价审核</div>
      <el-table
        ref="multipleTable"
        :data="pricetableData"
        border
        size="mini"
        style="width: 100%"
      >
        <el-table-column type="selection" width="54"></el-table-column>
        <el-table-column
          v-for="(item, index) in pricetableColumns"
          :key="index"
          :prop="item.class"
          :label="item.labelName"
          :sortable="item.sortEnable"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span v-if="scope.column.property == 'isDecisionBase'">{{
              scope.row[scope.column.property] == "1" ? "是" : "否"
            }}</span>
            <span v-else-if="scope.column.property == 'isDiscard'">{{
              scope.row[scope.column.property] == "1"
                ? "是"
                : scope.row[scope.column.property] == "2"
                ? "部分作废"
                : ""
            }}</span>
            <span v-else>{{ scope.row[scope.column.property] }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          header-align="center"
          align="center"
          width="100"
        >
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="bidPlanDetail(scope.row, 'price')"
              >详情</el-button
            >
            <el-button
              type="text"
              size="small"
              @click="abandBid(scope.row, 'price')"
              v-if="scope.row.status == 3"
              >作废</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="item">
      <div class="title">采购文件审核</div>
      <el-table
        ref="multipleTable"
        :data="filetableData"
        border
        size="mini"
        style="width: 100%"
      >
        <el-table-column type="selection" width="54"></el-table-column>
        <el-table-column
          v-for="(item, index) in filetableColumns"
          :key="index"
          :prop="item.class"
          :label="item.labelName"
          :sortable="item.sortEnable"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span v-if="scope.column.property == 'isDecisionBase'">{{
              scope.row[scope.column.property] == "1" ? "是" : "否"
            }}</span>
            <span v-else-if="scope.column.property == 'isDiscard'">{{
              scope.row[scope.column.property] == "1"
                ? "是"
                : scope.row[scope.column.property] == "2"
                ? "部分作废"
                : ""
            }}</span>
            <span v-else>{{ scope.row[scope.column.property] }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          header-align="center"
          align="center"
          width="100"
        >
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="bidPlanDetail(scope.row, 'file')"
              >详情</el-button
            >
            <el-button
              type="text"
              size="small"
              @click="abandBid(scope.row, 'file')"
              v-if="scope.row.status == 3"
              >作废</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="item">
      <div class="title">联签单审核</div>
      <el-table
        ref="multipleTable"
        :data="ordertableData"
        border
        size="mini"
        style="width: 100%"
      >
        <el-table-column type="selection" width="54"></el-table-column>
        <el-table-column
          v-for="(item, index) in ordertableColumns"
          :key="index"
          :prop="item.class"
          :label="item.labelName"
          :sortable="item.sortEnable"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span v-if="scope.column.property == 'isDecisionBase'">{{
              scope.row[scope.column.property] == "1" ? "是" : "否"
            }}</span>
            <span v-else-if="scope.column.property == 'isDiscard'">{{
              scope.row[scope.column.property] == "1"
                ? "是"
                : scope.row[scope.column.property] == "2"
                ? "部分作废"
                : ""
            }}</span>
            <span v-else>{{ scope.row[scope.column.property] }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          header-align="center"
          align="center"
          width="100"
        >
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="bidPlanDetail(scope.row, 'order')"
              >详情</el-button
            >
            <el-button
              type="text"
              size="small"
              @click="abandBid(scope.row, 'order')"
              v-if="scope.row.status == 3"
              >作废</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import {
  getContralPrice, //获取控制价列表接口
  abandcontrolPrice, //作废
  getBidFile, //获取控制价列表接口
  abandBidFile, //作废
  getBidOrder,
  abandBidOrder,
} from "@/services/bidServices";
export default {
  name: "bidPlanMsg",
  props: {
    bidPlanCode: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      ProjectGMList: [], //审批对话框项目经理下拉列表
      pricetableColumns: [
        { class: "bidPlanCode", labelName: "采购计划编号", sortEnable: false },
        { class: "projectName", labelName: "项目名称", sortEnable: false },
        { class: "bidPlanItem", labelName: "采购计划事项", sortEnable: false },
        {
          class: "commitDeptName",
          labelName: "提报单位/部门",
          sortEnable: false,
        },
        { class: "approveComment", labelName: "审核内容", sortEnable: false },
        { class: "approvePrice", labelName: "审核金额", sortEnable: false },
        { class: "operateUserName", labelName: "提交人", sortEnable: false },
        { class: "operateTime", labelName: "提交时间", sortEnable: false },
        {
          class: "statusDisplayName",
          labelName: "审核状态",
          sortEnable: false,
        },
        { class: "isDiscard", labelName: "是否作废", sortEnable: false },
      ],
      filetableColumns: [
        // { class: "bidPlanNo", labelName: "控制价编号", sortEnable: false },
        { class: "bidPlanCode", labelName: "采购计划编号", sortEnable: false },
        { class: "projectName", labelName: "项目名称", sortEnable: false },
        { class: "bidPlanItem", labelName: "采购计划事项", sortEnable: false },
        { class: "projectName", labelName: "项目情况", sortEnable: false },
        { class: "commitDeptName", labelName: "提报单位", sortEnable: false },
        {
          class: "commitResponseUserName",
          labelName: "提报单位负责人",
          sortEnable: false,
        },
        { class: "handlingUserName", labelName: "经办人", sortEnable: false },
        // { class: "operateUserName", labelName: "提交人", sortEnable: false },
        { class: "operateTime", labelName: "提交时间", sortEnable: false },
        {
          class: "statusDisplayName",
          labelName: "审核状态",
          sortEnable: false,
        },
        { class: "isDiscard", labelName: "是否作废", sortEnable: false },
      ],
      ordertableColumns: [
        { class: "bidPlanCode", labelName: "采购计划编号", sortEnable: false },
        { class: "projectName", labelName: "项目名称", sortEnable: false },
        { class: "bidPlanItem", labelName: "采购计划事项", sortEnable: false },
        { class: "projectName", labelName: "项目情况", sortEnable: false },
        { class: "commitDeptName", labelName: "提报单位", sortEnable: false },
        {
          class: "commitResponseUserName",
          labelName: "提报单位负责人",
          sortEnable: false,
        },
        { class: "handlingUserName", labelName: "经办人", sortEnable: false },
        // { class: "operateUserName", labelName: "提交人", sortEnable: false },
        { class: "operateTime", labelName: "提交时间", sortEnable: false },
        {
          class: "statusDisplayName",
          labelName: "审核状态",
          sortEnable: false,
        },
        { class: "isDiscard", labelName: "是否作废", sortEnable: false },
      ],
      showAdvanceFilter: false,
      pricetableData: [],
      filetableData: [],
      ordertableData: [],
      btnAuthorize: {
        addBtn: { key: "create", btnEnable: false },
        modifyBtn: { key: "update", btnEnable: false },
        delBtn: { key: "delete", btnEnable: false },
        import: { key: "import", btnEnable: false }, //导入
        callback: { key: "callback", btnEnable: false }, //审核
        export: { key: "export", btnEnable: false },
        uploadFileBtn: { key: "uploadFileBtn", btnEnable: false },
      },
    };
  },
  mounted() {},
  watch: {
    bidPlanCode: {
      handler: function (newVal) {
        if (newVal) {
          this.initPriceList(); //获取控制价列表
          this.initFileList(); //获取采购文件列表
          this.initOrderList(); //获取审签单列表
        }
      },
      immediate: true,
    },
  },
  methods: {
    handleTimestamp() {
      this.$forceUpdate();
    },
    //获取控制价审核列表
    initPriceList() {
      let param = {
        tabIndex: 1,
        pageIndex: 1,
        pageSize: 10,
        bidPlanCode: this.bidPlanCode,
      };
      getContralPrice(param, true)
        .then((res) => {
          if (res.code == 10000000) {
            this.pricetableData = res.data;
          } else {
            if (res.code > 20000000) {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定",
              });
            } else {
              this.$alert("系统异常", "提示", {
                confirmButtonText: "确定",
              });
            }
          }
        })
        .catch((error) => {
          this.$message.error("系统异常");
        });
    },
    initFileList() {
      let param = {
        // currentUserId: this.currentUserId, // sessionStorage.getItem("userCode"),
        // sort: "name",
        // order: "asc",
        tabIndex: 0,
        pageIndex: this.currentPage,
        pageSize: this.pageSize,
        bidPlanCode: this.bidPlanCode,
      };
      getBidFile(param, true)
        .then((res) => {
          if (res.code == 10000000) {
            this.filetableData = res.data;
          } else {
            if (res.code > 20000000) {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定",
              });
            } else {
              this.$alert("系统异常", "提示", {
                confirmButtonText: "确定",
              });
            }
          }
        })
        .catch((error) => {
          this.$message.error("系统异常");
        });
    }, //
    initOrderList() {
      let param = {
        tabIndex: 0,
        pageIndex: this.currentPage,
        pageSize: this.pageSize,
        bidPlanCode: this.bidPlanCode,
      };
      getBidOrder(param, true)
        .then((res) => {
          if (res.code == 10000000) {
            this.ordertableData = res.data;
          } else {
            if (res.code > 20000000) {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定",
              });
            } else {
              this.$alert("系统异常", "提示", {
                confirmButtonText: "确定",
              });
            }
          }
        })
        .catch((error) => {
          this.$message.error("系统异常");
        });
    }, //
    //作废
    abandBid(row, type) {
      let apiName = abandcontrolPrice;
      let param = {};
      if (type == "price") {
        //控制价审核作废
        param.bidPriceId = row.id;
        apiName = abandcontrolPrice;
      } else if (type == "file") {
        param.bidFileId = row.id;
        apiName = abandBidFile;
      } else if (type == "order") {
        param.bidSignatureId = row.id;
        apiName = abandBidOrder;
      }

      this.$confirm("确认要执行作废操作?", "提示", {
        confirmButtonText: "确认",
      }).then(() => {
        apiName(param)
          .then((res) => {
            if (res.code == 10000000) {
              this.$alert("作废成功", "提示", {
                confirmButtonText: "确定",
              });
              if (type == "price") {
                //控制价审核作废
                this.initPriceList();
              } else if (type == "file") {
                this.initFileList();
              } else if (type == "order") {
                this.initOrderList();
              }
            } else if (res.code > 20000000) {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定",
              });
            } else {
              this.$alert("系统异常", "提示", {
                confirmButtonText: "确定",
              });
            }
          })
          .catch((error) => {
            this.$message.error("网络请求失败");
          });
      });
    },

    //双击跳转详情
    bidPlanDetail(row, type) {
      let param = {};
      param.id = row.id;
      if (type == "price") {
        //控制价审核
        param.routeId = "controlPriceDetail";
        // param.uploadBtn = this.btnAuthorize.uploadFileBtn.btnEnable;
        this.bus.$emit("navMenuChange", {
          routeId: "controlPriceDetail",
          routeParam: param,
        });
      } else if (type == "file") {
        param.routeId = "bidFileDetail";
        // param.uploadBtn = this.btnAuthorize.uploadFileBtn.btnEnable;
        this.bus.$emit("navMenuChange", {
          routeId: "bidFileDetail",
          routeParam: param,
        });
      } else if (type == "order") {
        param.routeId = "bidOrderDetail";
        // param.uploadBtn = this.btnAuthorize.uploadFileBtn.btnEnable;
        this.bus.$emit("navMenuChange", {
          routeId: "bidOrderDetail",
          routeParam: param,
        });
      }
    },
  },
};
</script>
<style scoped lang="scss">
@import "@/assets/css/commonLayout.scss";

.orderManager {
  height: 100%;
  background-color: white;

  .item {
    .title {
      height: 44px;
      // padding-left: 24px;
      box-shadow: 0px 1px 0px 0px rgba(238, 238, 238, 1);
      border-radius: 2px 2px 0px 0px;
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.85);
      line-height: 44px;
      text-align: left;
      margin-bottom: 10px;
    }
  }
}
</style>
